<template>
    <div class="mt20">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
            <div class="inline-block font14px text-bold mb10">内容配置</div>
            <el-form-item label="新计划状态：" prop="new_status">
                <el-radio-group v-model="ruleForm.new_status">
                    <el-radio label="0">关闭</el-radio>
                    <el-radio label="1">开启</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="被复制计划状态：" prop="old_status">
                <el-radio-group v-model="ruleForm.old_status">
                    <el-radio label="2">不变</el-radio>
                    <el-radio label="0">关闭</el-radio>
                    <el-radio label="1">开启</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="被复制计划状态：" prop="type">
                <el-radio-group v-model="ruleForm.type">
                    <el-radio-button label="0">长期投放</el-radio-button>
                    <el-radio-button label="1">指定开始和结束日期</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="date" v-if="ruleForm.type=='1'">
                <el-date-picker
                v-model="ruleForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="basePickerOptions"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="复制计划命名：">
                <p class="font12px" :style="{paddingTop: '4px'}">在原计划与广告组名称上拼接开始投放日期与创建时间(如:_230110_230109102223)(长期投放名称中不拼接投放日期)</p>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import _ from 'lodash'
import dayjs from "dayjs";
export default {
  name: 'componentsCopyConfig',
  props: {
    config: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    const validate = (rule, value, callback) => {
      if (this.ruleForm.type == '1') {
        if (value.length == 0) {
          callback(new Error('必填项不可为空'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        new_status: '0',
        old_status: '2',
        type: '1',
        date:[],
        start_date: '',
        end_date: ''
      },
      rules: {
        new_status: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        old_status: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        date: [
          { validator: validate, trigger: 'blur' }
        ]
      },
      basePickerOptions: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 1000*60*60*24;
        }
      }
    }

  },
  watch: {
    'ruleForm.type': {
      deep: true,
      handler(val) { 
        if (val == '0') {
          this.ruleForm.date = []
          this.ruleForm.start_date = ''
          this.ruleForm.end_date = ''
        }else{
          const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');
          this.ruleForm.date = [tomorrow, tomorrow]
        }
      }
    },
    'config': {
      immediate: true,
      deep: true,
      handler(val) {
        
        if(this.$route?.params?.type == 'copy') {
          this.ruleForm.new_status = val.new_status || '0'
          this.ruleForm.old_status = val.old_status || '0'
          if (val.date != null && val.date?.length != 0 && !val.date?.every(item => item != '')) {
              this.ruleForm.type = '0'
          }else{
            const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');
            this.ruleForm.date = [tomorrow, tomorrow]
          }
        }
      }
    }
  },
  mounted() {
    if(this.$route?.params?.type == 'create') {
      const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD');
      this.ruleForm.date = [tomorrow, tomorrow]
    }
  },
  methods: {
    submitForm() {
        return new Promise((resolve, reject) => {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.ruleForm.type == '1') {
                      this.ruleForm.start_date = this.ruleForm.date[0]
                      this.ruleForm.end_date = this.ruleForm.date[1]
                    }
                    resolve(this.ruleForm)
                } else {
                    reject()
                }
            })
        })
    }

  }
}
</script>